export default {
  markerLayersToEdit: (state) => state.markerLayersToEdit,
  markerLayersMap: (state) => state.markerLayersMap,
  markerLayersMapPopup: (state) => state.markerLayersMapPopup,
  markerLayersMapUpdated: (state) => state.markerLayersMapUpdated,
  markerLayersEmitter: (state) => state.markerLayersEmitter,
  markerLayersEmitterContainerPlatform: (state) => state.markerLayersEmitterContainerPlatform,
  markerLayersBuilding: (state) => state.markerLayersBuilding,
  markerLayersBuildingEmitter: (state) => state.markerLayersBuildingEmitter,
  markerLayersContainerPlatform: (state) => state.markerLayersContainerPlatform,
  markerLayersContainer: (state) => state.markerLayersContainer,
  markerLayersContainers: (state) => state.markerLayersContainers,
  markerLayersEmitters: (state) => state.markerLayersEmitters,
  markerLayersEmitterCategories: (state) => state.markerLayersEmitterCategories,
  markerLayersContainerPlatforms: (state) => state.markerLayersContainerPlatforms,
  markerLayersContainerMaterials: (state) => state.markerLayersContainerMaterials,
  markerLayersContainerTypes: (state) => state.markerLayersContainerTypes,
  markerLayersContainerGraphics: (state) => state.markerLayersContainerGraphics,
}



// WEBPACK FOOTER //
// ./src/store/markerLayers/getters.js